import { createRoot } from 'react-dom/client';

import App from '@/App';
import { initSentry } from '@/utils/matrix';

if (window.location.origin === ORIGIN_URL) {
  initSentry({
    dsn: MATRIX_DSN,
    origin: ORIGIN_URL,
    release: BUILD_VERSION
  });
}

const app = document.getElementById('app');
if (app) {
  const root = createRoot(app);
  root.render(<App />);
}
